export default "__VITE_ASSET__B_r84nCG__"